export enum PluginType {
  STORAGE = 'storage',
  INVOICE = 'invoice',
  VALIDATION = 'validation',
  DOCS = 'docs'
}
